export default __webpack_public_path__ + "static/media/check-success.14dd9a2b.svg";